import { createCache } from '@/utils/cache';
import { operations } from './generated/gcss';
import { GCSS_URLS } from '@/constants/api';
import { apiGcssFetcher } from '@/api/fetcher';
import { primeGcssCategoryCache } from '@/sections/gcss/functions/utils';

export type CategoryListResponse =
	| operations['categories']['responses']['200']['content']['application/json']
	| undefined;

const MAX_CACHE_SIZE = 7000;

const cache = createCache<NonNullable<CategoryListResponse>[number]>(
	MAX_CACHE_SIZE,
	'gcss-categories'
);

export async function getCategoriesList(): Promise<NonNullable<CategoryListResponse>> {
	const data = await loadCategoriesList();

	await primeGcssCategoryCache(data.map((category) => category.id));

	return data;
}

async function loadCategoriesList(): Promise<NonNullable<CategoryListResponse>> {
	if (cache.size > 0) {
		return Array.from(cache.values());
	}

	const res = await apiGcssFetcher<Promise<CategoryListResponse>>(GCSS_URLS.categoryList);

	const data = await res?.json;

	if (!data) {
		return [];
	}

	for (const category of data) {
		cache.set(category.id.toString(), category);
	}

	return data;
}
